export default __webpack_public_path__ + "static/media/formationthefortifyingstandard.85aeaeed.png";